const TIME_IN_MILLISECONDS = Object.freeze({
  HOUR: 3600000,
  MINUTE: 60000,
  SECOND: 1000,
});

function getTime(milliseconds, format) {
  if (format === 'hour') return milliseconds / TIME_IN_MILLISECONDS.HOUR;
  if (format === 'minute') return milliseconds / TIME_IN_MILLISECONDS.MINUTE;
  if (format === 'second') return milliseconds / TIME_IN_MILLISECONDS.SECOND;
  return 0;
}

export function getHours(milliseconds) {
  return getTime(milliseconds, 'hour');
}

export function getMinutes(milliseconds) {
  return getTime(milliseconds, 'minute');
}

export function getSeconds(milliseconds) {
  return getTime(milliseconds, 'second');
}

export function getMonthRange() {
  const date = new Date();
  const currentYear = date.getFullYear();
  const currentMonth = date.getMonth() + 1; // currentMonth starts from '0
  const currentDay = date.getDate() + 1; // because all queries ate like "< currentDate" and exclude current stuff

  // END DATE
  const endMonth = String(currentMonth).length > 1 ? String(currentMonth) : `0${String(currentMonth)}`;
  const endDay = String(currentDay).length > 1 ? String(currentDay) : `0${String(currentDay)}`;
  const endDate = `${currentYear}-${endMonth}-${endDay}`;

  // START DATE
  let startDate = '';
  if (endMonth === '01') {
    const startMonth = '12';
    const startDay = String(currentDay).length > 1 ? String(currentDay) : `0${String(currentDay)}`;
    startDate = `${currentYear - 1}-${startMonth}-${startDay}`;
  } else {
    const startMonth = String(currentMonth - 1).length > 1 ? String(currentMonth - 1) : `0${String(currentMonth - 1)}`;
    let startDay = String(currentDay).length > 1 ? String(currentDay) : `0${String(currentDay)}`;
    if (endMonth !== '08' && currentDay === 31) {
      if (endMonth === '03') {
        // IF LEAP YEAR
        if (((currentYear % 4 === 0) && (currentYear % 100 !== 0)) || (currentYear % 400 === 0)) {
          startDay = currentDay === 31 ? '29' : currentDay;
        } else {
          startDay = currentDay === 31 ? '28' : currentDay;
        }
      } else {
        startDay = currentDay === 31 ? '30' : currentDay;
      }
    }
    startDate = `${currentYear}-${startMonth}-${startDay}`;
  }
  return { start: startDate, end: endDate };
}
